import { Box, Text } from '@factorialco/deprecated-design-system'
import type moment from 'moment'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  amount: number | string
  referenceDate: moment.Moment
}

const Total = ({ amount, referenceDate }: Props) => {
  const dateLabel = referenceDate.isSame(new Date(), 'day')
    ? i18n.t('time_off.available_tooltip.today')
    : referenceDate.format('LL')

  return (
    <Box>
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text.Normal color="grey000White">
          {i18n.t('time_off.available_tooltip.available')}
        </Text.Normal>
        <Text.Normal color="grey000White">{amount || 0}</Text.Normal>
      </Box>
      <Box flexDirection="row" justifyContent="flexStart">
        <Text.Normal size="200" color="grey000White">
          {dateLabel}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default observer(Total)
